import Server, { Provider } from '../types/Server'

export const PROVIDER_NAMES: Record<Provider, string> = {
  hetzner: 'Hetzner',
  contabo: 'Contabo',
}

export const serverKey = (server: Server) => `${server.provider}-${server.id}`

export const VAT_RATE = 1.19

// Monthly price incl. one IPv4 and 19% German VAT — what the table shows.
export function grossPrice(server: Server): number {
  return Math.round((server.price + server.ip_price.Monthly) * VAT_RATE * 100) / 100
}

export function formatEuro(value: number): string {
  return `${value.toFixed(2)} €`
}

// Hetzner: "FSN1-DC14" -> "FSN1"; Contabo names a region, not a datacenter
export function locationOf(server: Server): string {
  return server.provider === 'hetzner' ? server.datacenter.split('-')[0] : server.datacenter
}

export function formatDiskSize(gb: number): string {
  // Sizes mix decimal (3840, 6000) and binary (1024, 2048) values; round so
  // 1024 renders as "1.02 TB" instead of "1.024 TB".
  return gb >= 1000 ? `${Number((gb / 1000).toFixed(2))} TB` : `${gb} GB`
}

// [512, 512, 2000] -> "2× 512 GB, 1× 2 TB"
export function diskSummary(sizes: number[]): string {
  const counts = new Map<number, number>()
  for (const size of sizes) {
    counts.set(size, (counts.get(size) ?? 0) + 1)
  }
  return [...counts.entries()]
    .sort(([a], [b]) => a - b)
    .map(([size, count]) => `${count}× ${formatDiskSize(size)}`)
    .join(', ')
}

export function formatDuration(seconds: number): string {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  if (hours >= 24) {
    const days = Math.floor(hours / 24)
    return `${days}d ${hours % 24}h`
  }
  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`
}
